import createSvgIcon from '../Utils/CreateSvgIcon';

export const Read = createSvgIcon(
  <path
    d="M5 5L19 5L19 19H5L5 5ZM3 3L5 3H19H21V5L21 19L21 21H19H5H3V19V5V3ZM7 9L17 9V7L7 7V9ZM15 13H7V11H15V13ZM7 17H13V15H7V17Z"
    fillRule="evenodd"
  />,
  'Read',
);
